import {
  DatePipe,
  NgFor,
  NgIf,
  AsyncPipe,
} from "@angular/common";
import { Component } from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Incidencias } from "src/app/shared/model/incidencias/incidencia.model";
import swal from "sweetalert2";
import { Empleado } from "src/app/shared/model/empleado/empleado.model";
import { MatButtonModule } from "@angular/material/button";
import {
  MatFormField,
  MatLabel,
  MatInput,
  MatSuffix,
} from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatSelect, MatSelectTrigger } from "@angular/material/select";
import { MatOption } from "@angular/material/autocomplete";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from "@angular/material/datepicker";
import { SoloNumeroEnteroDirective } from "../../utilerias/directives/solo-numero-entero.directive";
import { CardIncComponent } from "../card-incidencia/card-inc.component";
import { IconosColumnas, ListaIncidenciasBase } from "../listas-comun/lista-incidencias-base";

/** Tablero de incidencias de desarrollo; la lógica común con el de QA vive en ListaIncidenciasBase. */
@Component({
  selector: "app-incidenciadesa",
  standalone: true,
  templateUrl: "./incidenciades.component.html",
  styleUrls: ["./incidenciades.component.css"],
  providers: [DatePipe],
  imports: [
    MatButtonModule,
    MatFormField,
    MatSelect,
    FormsModule,
    MatOption,
    MatIconModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    NgFor,
    MatLabel,
    NgIf,
    MatSelectTrigger,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    SoloNumeroEnteroDirective,
    CardIncComponent,
    AsyncPipe,
  ],
})
export class IncidenciaDesa extends ListaIncidenciasBase {
  public IncSelProy: string = "incDesSelProy";
  public IncSelEtapa: string = "incDesSelEtapa";
  peAbierto: number = 1;

  protected readonly iconosColumnas: IconosColumnas = {
    abierto: "lock_open",
    observaciones: "visibility",
    proceso: "find_in_page",
    resuelto: "done_all",
    revision: "settings_applications",
    vobo: "check_circle",
    cancelado: "cancel",
  };
  protected readonly puestoEmpleados = "Desarrollador";
  protected readonly campoUsuario = "id_usuario_desarrollo";

  /** Verifica que tipo de usuario es (Líder / Tester) */
  protected asignaUsuarioPorPuesto(emp: Empleado): void {
    if (
      emp.puesto.puesto === "Desarrollador" ||
      emp.puesto.puesto === "DESARROLLADOR" ||
      emp.puesto.puesto === "desarrollador"
    ) {
      this.idUsuario = emp.usuario.id;
      this.esDesarrolloDesarrollador = true;
    }
  }

  protected override alCambiarEtapa(): void {
    this.cargaCatalogosFiltros();
  }

  detallesIncidencia(row: Incidencias) {
    this.router.navigate(["/INCIDENCIAS/INC_DESARROLLO/detalle", row.id], {
      state: { incidencia: row, proyecto: this.proy },
    });
  }

  prepararFiltrosDisponibles() {
    this.cargaCatalogosFiltros();
    this.search = true;
  }

  limpiaFiltros() {
    this.fec_ini = null;
    this.fec_fin = null;
    this.prioridades = new FormControl();
    this.titulo = "";
    this.verestatus = new FormControl();
    this.numeroInci = null;
    this.idUsuario = null;
    this.tipos = new FormControl();
    this.applyFiltersIncidencias();
  }

  limpiaFiltrosPopup() {
    this.limpiaFiltros();
  }

  override cerrarFiltrosPopup() {
    this.search = false;
    super.cerrarFiltrosPopup();
  }

  protected avisaFechaInicial(): void {
    swal.fire({
      title: " Ingresa una Fecha Inicial ",
      timer: 5000,
      icon: "warning",
      confirmButtonColor: "btn-danger",
      showConfirmButton: true,
    });
  }

  private cargaCatalogosFiltros(): void {
    if (!this.selectEtapa) {
      return;
    }

    this.cargaPrioridades();
    this.cargaTipos();
    this.cargaEmpleados();
  }
}
